import React from 'react';

const Description = () => {
    return (
        <div className='Descr'>

        <p><span>React</span> developer with advanced programming and design skills.
        <span> HTML, CSS, Vanilla Javascript, ES6, jQuery, Bootstrap,</span> several  animataion libraries are commonly used tools during project development.
        On client’s demand, I can offer <span>Sketch</span> design and <span>prototyping</span> with nice <span>animations</span> and <span>interactions</span> made with <span>InVision.</span></p>
            
        </div>
    );
};

export default Description;